export default __webpack_public_path__ + "static/media/frame.f8fd17f1.svg";